import(/* webpackMode: "eager", webpackExports: ["ClientPage"] */ "/opt/build/repo/apps/studio-web/app/[[...slug]]/client-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getVariantIdCookie","setVariantIdCookie"] */ "/opt/build/repo/apps/studio-web/utils/analytics.ts");
